import { resourceNames } from '@/utils/analytics';

export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp();

  const path = removeLanguagePrefix(to.path, nuxtApp);
  const logoutUrl = nuxtApp.$i18n.t('url.logout');

  if (path === logoutUrl) {
    return;
  }

  const userStore = useUserStore();

  if (userStore.getIsAuthenticated) {
    await nuxtApp.runWithContext(() => userStore.setSoftloginState());
    await useDatalayerStore(nuxtApp.$pinia).loadAnalytics(nuxtApp, [
      resourceNames.USER,
      resourceNames.CART,
      resourceNames.WISHLIST,
    ]);
  }
});
